import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/site";
import { CheckCircle2 } from "lucide-react";

export default function ThankYou() {
  return (
    <div className="section px-6 lg:px-10 min-h-[70vh] flex items-center" data-testid="thank-you-page">
      <div className="max-w-3xl">
        <CheckCircle2 className="w-16 h-16 text-[#FF5722]" />
        <div className="eyebrow mt-6">Request Received</div>
        <h1 className="font-display text-6xl md:text-8xl tracking-tighter leading-[0.9] mt-4">
          Thank <span className="text-[#FF5722]">you.</span>
        </h1>
        <p className="mt-8 text-zinc-300 text-lg leading-relaxed max-w-2xl">
          Your request is in our queue. Expect a response from our estimating team within one business day.
          For urgent needs, call {COMPANY.phone} — {COMPANY.hours}.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/" className="btn-primary" data-testid="thank-you-home">Back to Home</Link>
          <Link to="/services" className="btn-ghost">Explore Services</Link>
        </div>
      </div>
    </div>
  );
}
